import React from 'react';

import './training-policies-sidebar.styles.scss';

function TrainingPolices({ buttonText }) {
  return (
    <div className="cart-sidebar">
      <div
        dangerouslySetInnerHTML={{
          __html:
            `<h3 style="font-size: 12px; font-weight: bold; margin-bottom: 10px; margin-left:-5px; text-align:left;margin-top:16px">Training Registration Policies</h3>
            <ul style="font-size: 12px; line-height: 1.6; color: #000000; padding-left: 16px; text-align:left;">
              <li>Course fees are payable upon registration.</li>
              <li>Only one discount can be applied to your purchase.</li>
              <li>The course fee is per attendee. Recording our courses is strictly prohibited.</li>
              <li>Recordings of paid, virtual courses will not be provided.</li>
              <li>
                Cancellations received more than 72 hours prior to a course are eligible for a full refund or transfer to another course.
                Cancellations received less than 72 hours prior to a course may be transferred to another course; however, no refund will be provided.
                If Trinity Consultants cancels a course, full refunds will be provided.
              </li>
              <li>
                Trinity Consultants assumes no responsibility for participants’ travel expenses including, in the case of course cancellation, reimbursement for non-refundable reservations.
              </li>
              <li>
                These courses are intended primarily for environmental professionals from industry and government agencies.
                Trinity Consultants reserves the right to decline registrations at its discretion to persons for whom its courses may not be intended.
              </li>
            </ul>`,
        }}
      />
    </div>
  );
}

export default TrainingPolices;
